import React from 'react';

import { Site } from '@99designs/frontend-components/apps/global-nav/lib/Site';
import Bugsnag from '@bugsnag/js';
import Layout from '@99designs/apps/spa/common/Layout/Layout';

interface State {
    error?: Error;
}

interface Props {
    site: Site;
}

import ErrorView from '@99designs/apps/spa/common/FullscreenError/FullscreenError';

class ErrorBoundary extends React.Component<Props, State> {
    state: State = {};

    componentDidCatch(error: Error) {
        this.setState({ error });
    }

    render() {
        const { error } = this.state;

        if (error) {
            Bugsnag.notify(error);

            return (
                <Layout role="logged-out" site={this.props.site}>
                    <ErrorView error={error} errorCode="500" />
                </Layout>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
